import { TablelistProApi } from '@lib/api'
import { User } from 'types/model'
import { AdmissionGroup } from 'types/model/admission-group'
import { Booking, BookingCreateRequest, BookingReservationRequest } from 'types/model/booking'
import { BookingCheckoutSession } from 'types/model/checkout-session'
import { BookingTicket } from 'types/model/ticket'

class BookingApi extends TablelistProApi<Booking> {
  constructor() {
    super('/booking')
  }

  async createBooking(payload: BookingCreateRequest): Promise<Booking> {
    return await this.post<Booking, BookingCreateRequest>(this.basePath, payload)
  }

  async duplicateBooking(booking: Booking, user?: User | null, options?: any): Promise<Booking> {
    const bookingRequest: BookingCreateRequest = {
      affiliateId: booking.affiliate ?? null,
      attributionId: booking.attributionId ?? null,
      items: booking.items.map((item) => ({
        inventoryId: item.inventory.id!,
        quantity: item.quantity,
      })),
      payment: null,
      phone: user?.phone,
      pickUpType: null,
      status: 'OPEN',
      trackingId: null,
      type: 'USER',
      ...options,
    }
    return this.createBooking(bookingRequest)
  }

  async applyDiscount(id: string, promoCode: string) {
    const response = await this.post<Booking, { id: string; promoCode: string }>(
      `${this.basePath}/${id}/booking-discount`,
      { id, promoCode }
    )

    return response
  }

  async beginCheckoutSession(id: string, body: { cancelUrl: string; successUrl: string }) {
    const response = await this.post<BookingCheckoutSession, { cancelUrl: string }>(
      `${this.basePath}/${id}/checkout-session`,
      body
    )
    return response
  }

  async complete(id: string) {
    const response = await this.post<Booking>(`${this.basePath}/${id}/complete`, {})
    return response
  }

  async getTickets(id: string) {
    const response = await this.get<BookingTicket[]>(`${this.basePath}/${id}/ticket`)
    return response
  }

  async requestReservation(vals: BookingReservationRequest) {
    const response = await this.post<AdmissionGroup, BookingReservationRequest>(
      `/admission-group-request`,
      vals
    )
    return response
  }
}

export const bookingApi = new BookingApi()
